export const PARTNER_NAV = [
  {
    "title": "Rekan",
    "link": "#",
    "childItems": [
      {
        "title": "Asuransi Mobil Garda Oto",
        "link": "/produk/asuransi-mobil/garda-oto/",
      },
      {
        "title": "Asuransi Mobil Zurich Syariah",
        "link": "/produk/asuransi-mobil/zurich-autocillin/",
      },
      {
        "title": "Asuransi Mobil ACA",
        "link": "/produk/asuransi-mobil/aca/",
      },
      {
        "title": "Asuransi Mobil Roojai-Sompo",
        "link": "/produk/asuransi-mobil/sompo/",
      },
      {
        "title": "Asuransi Mobil Mega Insurance",
        "link": "/produk/asuransi-mobil/mega/",
      },
      {
        "title": "Asuransi Mobil Simas Insurtech",
        "link": "/produk/asuransi-mobil/simas-insurtech/",
      },
      {
        "title": "Asuransi Mobil Oona",
        "link": "/produk/asuransi-mobil/oona/",
      },
      {
        "title": "Asuransi Mobil MAG",
        "link": "/produk/asuransi-mobil/mag/",
      },
      {
        "title": "Asuransi Kesehatan Roojai",
        "link": "/produk/asuransi-kesehatan/roojai/",
      },
      {
        "title": "Asuransi Kesehatan Sinar Mas",
        "link": "/produk/asuransi-kesehatan/sinar-mas/",
      },
      {
        "title": "Asuransi Kesehatan AXA",
        "link": "/produk/asuransi-kesehatan/axa/",
      },
      {
        "title": "Asuransi Kesehatan Lippo General Insurance",
        "link": "/produk/asuransi-kesehatan/lippo/",
      },
      {
        "title": "Asuransi Kesehatan CAR Life",
        "link": "/produk/asuransi-kesehatan/car/",
      },
      {
        "title": "Asuransi Kesehatan MAG",
        "link": "/produk/asuransi-kesehatan/mag/",
      }
    ],
  }
];